import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DuplicateIcon = function DuplicateIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: "1em",
    height: "1em"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 12,
      d: "M168 168h48V40H88v48"
    }), /*#__PURE__*/_jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 12,
      d: "M40 88h128v128H40z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M138.14 152.43a4.46 4.46 0 0 1-4.45 4.46h-25.26v25.25a4.46 4.46 0 0 1-8.92 0v-25.25H74.26a4.46 4.46 0 0 1 0-8.92h25.25v-25.26a4.46 4.46 0 0 1 8.92 0V148h25.26a4.46 4.46 0 0 1 4.45 4.43Z"
    })]
  }));
};
export default DuplicateIcon;